import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';
import { withStyles } from '@material-ui/styles';
import { primary1000 } from 'themes/colors';

const styles = () => ({
  root: {
    width: '3rem',
    height: '3rem',
    cursor: 'pointer',
  },
});

/* eslint-disable max-len */
const Plus = (props) => {
  const { classes } = props;
  return (
    <SvgIcon classes={{ root: classes.root }} {...props} viewBox="0 0 48 48">
      <path d="M0 6C0 4.4087 0.632141 2.88258 1.75736 1.75736C2.88258 0.632141 4.4087 0 6 0L42 0C43.5913 0 45.1174 0.632141 46.2426 1.75736C47.3679 2.88258 48 4.4087 48 6V42C48 43.5913 47.3679 45.1174 46.2426 46.2426C45.1174 47.3679 43.5913 48 42 48H6C4.4087 48 2.88258 47.3679 1.75736 46.2426C0.632141 45.1174 0 43.5913 0 42L0 6Z" fill="white" />
      <path d="M0 6C0 2.68629 2.68629 0 6 0H42C45.3137 0 48 2.68629 48 6V42C48 45.3137 45.3137 48 42 48H6C2.68629 48 0 45.3137 0 42V6Z" fill={primary1000} />
      <path d="M18 25C17.7348 25 17.4804 24.8946 17.2929 24.7071C17.1054 24.5196 17 24.2652 17 24C17 23.7348 17.1054 23.4804 17.2929 23.2929C17.4804 23.1054 17.7348 23 18 23H23V18C23 17.7348 23.1054 17.4804 23.2929 17.2929C23.4804 17.1054 23.7348 17 24 17C24.2652 17 24.5196 17.1054 24.7071 17.2929C24.8946 17.4804 25 17.7348 25 18V23H30C30.2652 23 30.5196 23.1054 30.7071 23.2929C30.8946 23.4804 31 23.7348 31 24C31 24.2652 30.8946 24.5196 30.7071 24.7071C30.5196 24.8946 30.2652 25 30 25H25V30C25 30.2652 24.8946 30.5196 24.7071 30.7071C24.5196 30.8946 24.2652 31 24 31C23.7348 31 23.4804 30.8946 23.2929 30.7071C23.1054 30.5196 23 30.2652 23 30V25H18Z" fill="white" />
    </SvgIcon>
  );
};

export default withStyles(styles)(Plus);
